let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3yxk6")).then(() => parcelRequire('02KwK'));